export const submitAllStarVote = `
mutation($input: SubmitAllStarVoteInput!){
  submitAllStarVote(input: $input){
    position
    teamId
    playerId
  }
}
`